import { render, staticRenderFns } from "./RadialChart.vue?vue&type=template&id=35f1c76c"
import script from "./RadialChart.vue?vue&type=script&lang=js"
export * from "./RadialChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports